import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import UpcomingIcon from '@mui/icons-material/Upcoming'
import ViewListIcon from '@mui/icons-material/ViewList'
import PeopleIcon from '@mui/icons-material/People'

export const MENTOR_CLINIC_BOOKING_TABS = {
  calendar: {
    id: 'calendar',
    title: 'Calendar',
    icon: CalendarTodayIcon,
    roleType: ['ROLE_THERAPIST', 'ROLE_DOCTOR', 'ROLE_CLINIC_ASSISTANT'],
  },
  appointments: {
    id: 'appointments',
    title: 'Appointments',
    icon: ViewListIcon,
    roleType: ['ROLE_THERAPIST', 'ROLE_DOCTOR', 'ROLE_CLINIC_ASSISTANT'],
  },
  planned: {
    id: 'planned',
    title: 'Planned',
    icon: UpcomingIcon,
    roleType: ['ROLE_THERAPIST', 'ROLE_DOCTOR'],
  },
  roster: {
    id: 'roster',
    title: 'My Roster',
    icon: CalendarTodayIcon,
    roleType: ['ROLE_THERAPIST'],
  },
  patients: {
    id: 'patients',
    title: 'Patients',
    icon: PeopleIcon,
    roleType: ['ROLE_CLINIC_ASSISTANT'],
  },
}

export const MENTOR_CLINIC_BOOKING_TABS_LIST = Object.values(MENTOR_CLINIC_BOOKING_TABS)
